import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail2 = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 142,
	viewBox: "0 0 412 142",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 282.93,
			y1: 130.444,
			x2: 206.93,
			y2: 118.444,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 55.4437,
			y2: -.45,
			transform: "matrix(0.991998 0.126254 0.126254 -0.991998 340 64)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 64.0078,
			y2: -.45,
			transform: "matrix(0.484316 -0.874893 -0.874893 -0.484316 297 127)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 56C336.418 56 340 59.5817 340 64C340 68.4183 336.418 72 332 72C327.582 72 324 68.4183 324 64C324 59.5817 327.582 56 332 56Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 61C333.657 61 335 62.3431 335 64C335 65.6569 333.657 67 332 67C330.343 67 329 65.6569 329 64C329 62.3431 330.343 61 332 61Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 64C407.418 64 411 67.5817 411 72C411 76.4183 407.418 80 403 80C398.582 80 395 76.4183 395 72C395 67.5817 398.582 64 403 64Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 69C404.657 69 406 70.3431 406 72C406 73.6569 404.657 75 403 75C401.343 75 400 73.6569 400 72C400 70.3431 401.343 69 403 69Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292 125C296.418 125 300 128.582 300 133C300 137.418 296.418 141 292 141C287.582 141 284 137.418 284 133C284 128.582 287.582 125 292 125Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M292 130C293.657 130 295 131.343 295 133C295 134.657 293.657 136 292 136C290.343 136 289 134.657 289 133C289 131.343 290.343 130 292 130Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 127.393,
			y1: 74.5857,
			x2: 195.824,
			y2: 45.5857,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 72.0568,
			y1: 9.4464,
			x2: 17.0568,
			y2: 16.4464,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 114.606,
			y1: 72.2179,
			x2: 83.6063,
			y2: 16.2179,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80 1C75.5817 1 72 4.58172 72 9C72 13.4183 75.5817 17 80 17C84.4183 17 88 13.4183 88 9C88 4.58172 84.4183 1 80 1Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80 6C78.3431 6 77 7.34314 77 9C77 10.6569 78.3431 12 80 12C81.6569 12 83 10.6569 83 9C83 7.34314 81.6569 6 80 6Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 9C4.58172 9 1 12.5817 1 17C1 21.4183 4.58172 25 9 25C13.4183 25 17 21.4183 17 17C17 12.5817 13.4183 9 9 9Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 14C7.34315 14 6 15.3431 6 17C6 18.6569 7.34315 20 9 20C10.6569 20 12 18.6569 12 17C12 15.3431 10.6569 14 9 14Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120 70C115.582 70 112 73.5817 112 78C112 82.4183 115.582 86 120 86C124.418 86 128 82.4183 128 78C128 73.5817 124.418 70 120 70Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M120 75C118.343 75 117 76.3431 117 78C117 79.6569 118.343 81 120 81C121.657 81 123 79.6569 123 78C123 76.3431 121.657 75 120 75Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M359.3 94.65C359.3 96.67 357.67 98.3 355.65 98.3C353.63 98.3 352 96.67 352 94.65C352 92.63 353.63 91 355.65 91C357.67 91 359.3 92.63 359.3 94.65Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M43.2999 47.65C43.2999 49.67 41.6699 51.3 39.6499 51.3C37.6299 51.3 36 49.67 36 47.65C36 45.63 37.6299 44 39.6499 44C41.6699 44 43.2999 45.63 43.2999 47.65Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.0426 101.173C50.8326 101.183 50.6226 101.133 50.4326 101.003C49.9826 100.693 49.8626 100.083 50.1726 99.6326L55.9326 91.1926C56.1026 90.9426 56.3826 90.7826 56.6826 90.7626C56.9626 90.7326 57.2826 90.8627 57.4826 91.0827L61.2026 95.1726L67.8726 84.1326C68.0326 83.8726 68.2926 83.7026 68.5926 83.6626C68.8926 83.6326 69.1926 83.7326 69.4126 83.9426L73.4626 87.9727L82.0126 75.4326C82.3226 74.9826 82.9326 74.8626 83.3826 75.1726C83.8326 75.4826 83.9527 76.0926 83.6427 76.5426L74.4326 90.0626C74.2726 90.3026 74.0026 90.4627 73.7126 90.4927C73.4026 90.5327 73.1326 90.4127 72.9226 90.2127L68.9226 86.2327L62.2226 97.3327C62.0626 97.6027 61.7826 97.7726 61.4726 97.8026C61.1426 97.8426 60.8526 97.7127 60.6426 97.4827L56.8726 93.3427L51.8226 100.753C51.6426 101.013 51.3526 101.163 51.0626 101.183L51.0426 101.173Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M284.043 18.01C283.833 18 283.623 18.0499 283.433 18.1799C282.983 18.4899 282.863 19.1 283.173 19.55L288.933 27.99C289.103 28.24 289.383 28.4001 289.683 28.4201C289.963 28.4501 290.283 28.32 290.483 28.1L294.203 24.01L300.873 35.0501C301.033 35.3101 301.293 35.48 301.593 35.52C301.893 35.55 302.193 35.45 302.413 35.24L306.463 31.21L307.5 30.1826C307.628 29.9243 307.593 29.36 307.433 29.12C307.273 28.88 307.003 28.7199 306.713 28.6899C306.403 28.6499 306.133 28.77 305.923 28.97L301.923 32.95L295.223 21.85C295.063 21.58 294.783 21.41 294.473 21.38C294.143 21.34 293.853 21.47 293.643 21.7L289.873 25.84L284.823 18.4299C284.643 18.1699 284.353 18.02 284.063 18L284.043 18.01Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M144.782 54.2177C144.782 51.991 145.841 49.8972 147.635 48.5781L201.396 9.04896C203.863 7.23509 207.222 7.23509 209.689 9.04896L263.45 48.5781C265.244 49.8972 266.303 51.991 266.303 54.2177V118.459C266.303 122.325 263.169 125.459 259.303 125.459H151.782C147.916 125.459 144.782 122.325 144.782 118.459V54.2177Z",
			fill: "#3085E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M161.043 29.5664C161.043 26.5012 163.528 24.0164 166.593 24.0164H242.43C245.495 24.0164 247.98 26.5012 247.98 29.5664V91.6294H161.043V29.5664Z",
			fill: "white",
			stroke: "#D9DEEB",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.125 84.3346C198.186 85.1347 198.186 86.7286 197.125 87.5288L155.015 119.269C153.698 120.263 151.812 119.322 151.812 117.672L151.812 54.1912C151.812 52.5409 153.698 51.6007 155.015 52.5941L197.125 84.3346Z",
			fill: "#3085E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.411 84.3355C214.35 85.1357 214.35 86.7296 215.411 87.5298L257.521 119.27C258.839 120.264 260.725 119.323 260.725 117.673L260.725 54.1922C260.725 52.5418 258.839 51.6017 257.521 52.595L215.411 84.3355Z",
			fill: "#3085E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M186.067 39.3765H183.861L183.728 39.3779C183.321 39.3706 183.174 39.5281 183.052 39.7225L181.32 42.3855L179.66 39.776L179.605 39.6905C179.605 39.6905 179.559 39.6141 179.48 39.6113H179.479C179.4 39.6141 179.355 39.6905 179.355 39.6905L179.299 39.776L177.696 42.3855L175.907 39.7225C175.785 39.5281 175.638 39.3706 175.23 39.3779L175.098 39.3765H172.892L172.893 41.5509H174.192C174.466 41.5483 174.592 41.5615 174.78 41.7953L174.858 41.9135L177.482 46.1714C177.482 46.1714 177.567 46.3089 177.712 46.3098C177.868 46.3103 177.955 46.1711 177.955 46.1711L179.482 43.7954H179.483L181.072 46.1679C181.072 46.1679 181.161 46.3086 181.296 46.3121C181.441 46.3158 181.521 46.1711 181.521 46.1711L184.105 41.9135L184.182 41.7953C184.316 41.5774 184.486 41.5546 184.758 41.5573L186.059 41.5564L186.067 39.3765Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M182.745 45.421L181.332 47.746L179.51 45.0067L178.109 47.1929L181.068 52.0005C181.17 52.1334 181.251 52.1613 181.292 52.1627C181.382 52.1668 181.433 52.1171 181.53 51.9489L183.848 47.559C184.054 47.1777 184.399 47.1826 184.399 47.1826H186.072L186.07 45.011H183.458C182.982 45.011 182.745 45.421 182.745 45.421Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 219.872,
			y1: 41.5848,
			x2: 197.934,
			y2: 41.5848,
			stroke: "#E8EAF3",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 235.681,
			y1: 48.6111,
			x2: 197.932,
			y2: 48.6111,
			stroke: "#E8EAF3",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M211.188 76.5905C208.297 74.3369 204.244 74.3369 201.352 76.5905L163.774 105.88C157.77 110.56 161.079 120.189 168.692 120.189L243.848 120.189C251.461 120.189 254.771 110.56 248.766 105.88L211.188 76.5905Z",
			fill: "#3085E1"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 229.735,
			y1: 91.9898,
			x2: 250.096,
			y2: 107.261,
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .45,
			y1: -.45,
			x2: 25.9012,
			y2: -.45,
			transform: "matrix(-0.8 0.6 0.6 0.8 183.427 92.0808)",
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgEmail2);
export default ForwardRef;
